module.exports = __webpack_public_path__ + "img/LV_map.3ae6f240.svg";